module.exports = __webpack_public_path__ + "static/anderson-cooper-0a8d91ffb35c2deaf0606388ccac90b3.jpg";